import { s as t, _ as a } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as f, c as d } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var i = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  a({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, l),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M31.66 21.333a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32a50.558 50.558 0 0 1-5.334-.314V21.333H31.66Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M31.683 10.667H10.666V.314A50.525 50.525 0 0 1 16 0c3.75.033 7.567.432 9.69 1.263 4.447 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      d: "M3.921 3.71C5.438 6.371 7.317 8.453 9.56 9.95a.293.293 0 0 0 .388-.057.244.244 0 0 0-.063-.358c-2.17-1.449-3.994-3.47-5.472-6.066a.29.29 0 0 0-.375-.107c-.136.066-.188.22-.117.346Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      d: "M9.413 3.71C7.896 6.371 6.016 8.453 3.774 9.95a.293.293 0 0 1-.388-.057.244.244 0 0 1 .062-.358c2.17-1.449 3.994-3.47 5.473-6.066a.29.29 0 0 1 .375-.107c.136.066.188.22.117.346Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M3.611 5.897h5.556c.153 0 .278.115.278.257v.513c0 .141-.125.256-.278.256H3.61c-.153 0-.278-.115-.278-.256v-.513c0-.142.125-.257.278-.257Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m6.111 5.385.278-.513V3.848h.556v1.024l.277.513v2.564H4.306c-.23 0-.417-.172-.417-.385 0-.212.187-.385.417-.385H6.11V5.385Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M6.667 4.103c.307 0 .555-.115.555-.257 0-.141-.248-.256-.555-.256-.307 0-.556.115-.556.256 0 .142.25.257.556.257Z",
      clipRule: "evenodd"
    }
  )
), o = f(i)`
  ${t}
  ${d}
`, g = o;
export {
  g as default
};
